import moment from 'moment'
import convertShiftTimecheckin from './convertshiftcheckin';
import getTimeZoneAndOffset from './getTimeZoneAndOffset';

function TimeFormatter(inputTime,defaulttimezone) {
    const timezongetTimeZone= getTimeZoneAndOffset()
    const timezone = defaulttimezone != 3 ? defaulttimezone ? defaulttimezone : timezongetTimeZone : null
    const converttime = defaulttimezone != 3 ?  convertShiftTimecheckin(inputTime, timezone) : null
    let time = defaulttimezone == 3  ? inputTime : converttime
    let userFullDate = time.split(" ")[0];
    let userSplitedDate = userFullDate.split('-')
    let logTime = moment(time, "yyyy-MM-dd HH:mm:ss").format(`lll`)
    let logTimeWithDayname = moment(time, "YYYY-MM-DD HH:mm:ss").format(`ddd`)
    const logTimeWithFullMonthName = () => {
        let logTimeWithFullMonthName = moment(time, "YYYY-MM-DD HH:mm:ss").format(`LL`)
        return (logTimeWithFullMonthName.split(' ')[0])
    }
    
    let userMonth = logTime.split(',')[0].split(' ')[0]
    let userTime = logTime?.split(',')[1]?.split(' ')[2]+" "+logTime?.split(',')[1]?.split(' ')[3]
    let date_ob = new Date();
    let date = ("0" + date_ob.getDate()).slice(-2);

    let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
    let year = date_ob.getFullYear();
    const t = year + "-" + month + "-" + date
    userSplitedDate.push(logTimeWithDayname)
    const fullMonthName = moment(time, "YYYY-MM-DD HH:mm:ss")
  .format("MMMM")
  .toUpperCase();
    return (
        date = {
            CurDate : t,
            ShiftDate : userFullDate,
            ShiftMonth : userMonth,
            shiftFullMonth : logTimeWithFullMonthName(),
            fullMonthName:fullMonthName,
            ShiftTime : userTime,
            CurMonth : month,
            CurDateInTwoDigit : date,
            CurYear : year,
            userSplitedDate : userSplitedDate
        }
    )
}

export default TimeFormatter


export const TimeFormatterV2 = (date, inputFormat, outputFormat) => {
    let possibleOutputFormats = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD', 'HH:mm:ss', 'YYYY', 'DDDD', 'DD', 'dddd', 'ddd', 'MMMM', 'MM', 'shiftdayid']
    let possibleInputFormats = ['fulldate', 'dateonly', 'shiftdayid']
    let isInputFormatValid = false
    let isOutputFormatValid = false
    for (let i = 0; i < possibleOutputFormats.length; i++) {
        for (let j = 0; j < possibleInputFormats.length; j++) {
            if (inputFormat === possibleInputFormats[j]) {
                isInputFormatValid = true
                if (outputFormat === possibleOutputFormats[i]) {
                    isOutputFormatValid = true
                }
            }
        }
    }
    if (isInputFormatValid) {
        if (inputFormat === 'fulldate' || inputFormat === 'dateonly') {
            if (isOutputFormatValid) {
                if (outputFormat == 'shiftdayid') {
                    let yy = moment(date).format('YYYY').slice(-2)
                    let mm = moment(date).format('MM')
                    let dd = moment(date).format('DD')
                    let shiftdayid = `${yy}${mm}${dd}`
                    return shiftdayid
                } else {
                    return moment(date).format(outputFormat)
                }
            } else {
                throw 'Invalid Output Format'
            }
        } else if (inputFormat === 'shiftdayid') {
            if (isOutputFormatValid) {
                if (date.length == 6) {
                    if (outputFormat == 'shiftdayid') {
                        return date
                    } else {
                        let yyyy = '20' + date.slice(0, 2)
                        let mm = date.slice(2, 4)
                        let dd = date.slice(4, 6)
                        let newDate = `${yyyy}-${mm}-${dd}`
                        return moment(newDate).format(outputFormat)
                    }
                } else {
                    throw 'Invalid shiftdayid passed'
                }
            } else {
                throw 'Invalid Output Format'
            }
        }
    } else {
        throw 'Invalid Input Format'
    }
}